import { FC, MouseEvent, useCallback } from 'react';

import { Button, ButtonGroup } from 'reactstrap';

import { ExcludeInclude } from 'types/api/common';
import { IExcludeIncludeButtonGroupProps } from 'types/pages/audience-builder/components/shared';
import { s } from 'utilities/strings';

import './exclude-include.component.scss';

const ExcludeIncludeButtonGroup: FC<IExcludeIncludeButtonGroupProps> = ({ onToggle, value, disabled }) => {
  const handleOnButtonClick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => {
      const { target } = e;

      onToggle?.((target as HTMLButtonElement).dataset.value as ExcludeInclude);
    },
    [onToggle]
  );

  return (
    <div className="exclude-include-wrapper">
      <ButtonGroup>
        <Button
          active={value === 'include'}
          color={disabled ? 'gray' : 'primary'}
          data-value="include"
          disabled={disabled}
          onClick={handleOnButtonClick}
          outline
          type="button">
          {s('Site.Include')}
        </Button>
        <Button
          active={value === 'exclude'}
          color={disabled ? 'gray' : 'primary'}
          data-value="exclude"
          disabled={disabled}
          onClick={handleOnButtonClick}
          outline
          type="button">
          {s('Site.Exclude')}
        </Button>
      </ButtonGroup>
    </div>
  );
};

export default ExcludeIncludeButtonGroup;
